export default {"src":"/_next/static/media/img1.aaa5d3ca.svg","height":343,"width":478,"blurWidth":0,"blurHeight":0};